export default "<div id=\"mapView\" #esriMapDiv></div>\n";